import { render } from "./BlckAstucePopup.vue?vue&type=template&id=c877203a&scoped=true"
import script from "./BlckAstucePopup.vue?vue&type=script&lang=js"
export * from "./BlckAstucePopup.vue?vue&type=script&lang=js"

import "./BlckAstucePopup.vue?vue&type=style&index=0&id=c877203a&scoped=true&lang=css"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c877203a"]])

export default __exports__